<template>
    <rkm-area title="Paciente realizou tratamento prévio ou está em tratamento da doença?" type="fieldset">
        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-radio-group
                    label="Tratamento"
                    v-model="model.tratamentoPrevio.status"
                >
                    <rkm-form-radio
                        inline
                        :value="false"
                    >
                        Não
                    </rkm-form-radio>
                    
                    <rkm-form-radio
                        inline
                        :value="true"
                    >
                        Sim
                    </rkm-form-radio>
                </rkm-form-radio-group>
                
            </rkm-col>

            <rkm-col cols="9">
                <rkm-form-input
                    label="Relatar"
                    v-model="model.tratamentoPrevio.relatar"
                    :disabled="!model.tratamentoPrevio.status"
                    :validations="validations.relatar"
                    :maxLenght="90"
                />
                    <div style="font-size: 13px; color: gray; margin-top: 4px;">
                        Caracteres restantes:
                        {{ 90 - (model.tratamentoPrevio.relatar ? model.tratamentoPrevio.relatar.length : 0) }}
                    </div>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {

    props: {
        model: { type: Object, required: true }
    },
    watch: {
        'model.tratamentoPrevio.status'(value) {

            if (!value) {
                this.model.tratamentoPrevio.relatar = null
            }

        }
    },
    computed:{
        validations(){
            return {
                relatar:{
                    required: true,
                    max: 90
                }
            }
        }
    }

}
</script>